import { Component } from '@angular/core';

@Component({
  selector: 'app-outside-elvia-area',
  template: `<p>
    Vi kan desverre ikke hjelpe deg 😕.<br />Adressen du søkte på er utenfor Elvia sitt
    ansvarsområde.
  </p>`,
})
export class OutsideElviaAreaComponent {}
